import { SxProps, Theme } from "@mui/material/styles";

// Layout after the client's "ROS & PE Template" PDF: a bordered table, one
// bordered row per system with the system name rotated in a narrow left cell.
export const HOME_CARE_ROS_TABLE_SX: SxProps<Theme> = {
  border: "1.5px solid",
  borderColor: "primary.main",
  borderRadius: 2,
  overflow: "hidden",
};

export const HOME_CARE_ROS_ROW_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "stretch",
  borderBottom: "1px solid",
  borderColor: "primary.main",
  "&:last-of-type": { borderBottom: 0 },
};

export const HOME_CARE_ROS_LABEL_CELL_SX: SxProps<Theme> = {
  width: 40,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRight: "1px solid",
  borderColor: "primary.main",
  bgcolor: "action.hover",
};

export const HOME_CARE_ROS_LABEL_TEXT_SX: SxProps<Theme> = {
  writingMode: "vertical-rl",
  transform: "rotate(180deg)",
  color: "primary.main",
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 0.3,
  whiteSpace: "nowrap",
  py: 1,
};

export const HOME_CARE_ROS_OPTIONS_CELL_SX: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  px: 1.5,
  py: 0.5,
};

export const HOME_CARE_ROS_DETAILS_PLACEHOLDER = "Specify details";
export const HOME_CARE_ROS_DETAILS_MIN_WIDTH = 140;
// An option with its details box open takes two grid columns so the box never overlaps the next option.
export const HOME_CARE_ROS_DETAILS_COLUMN_SPAN = "span 2";

// Display text for option tokens whose stored spelling must stay as saved.
export const HOME_CARE_ROS_OPTION_LABELS: Record<string, string> = {
  Liability_Of_Mood: "Lability of mood",
};
